import { ChatContextInteractionType } from '@/components/chat/_domain/modules/chat-context-menu';

enum WindowType {
  Chat = 'Chat',
  Game = 'Game',
  IFrameGame = 'IFrameGame',
  ArcadeGame = 'ArcadeGame',
  GameWinners = 'GameWinners',
  UserSettings = 'UserSettings',
  PlayerNotes = 'PlayerNotes',
  ChatContextInteraction = 'ChatContextInteraction'
}

interface IWindowLaunchCondition {
  gameName: string;
  frontEndName: string;
  clubName?: string;
  chatRoomName?: string;
  id?: number;
  location?: IWindowLocationPreference;
  callbackFunction?: any;
  chatContextInteraction?: ChatContextInteractionType;
  playerUsername?: string;
}

interface IWindowLocationPreference {
  top: number;
  left: number;
  width: number;
  height: number;
}

class UserWindowPreference {
  public type: WindowType;
  public launchCondition: IWindowLaunchCondition;
  public location?: IWindowLocationPreference;
  public autoRestore: boolean;
}

export { WindowType, IWindowLaunchCondition, IWindowLocationPreference, UserWindowPreference };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/store/modules/user-preferences/user-window-preference.ts